import { render, staticRenderFns } from "./RandomCharacter.vue?vue&type=template&id=14ae69b8&lang=pug&"
import script from "./RandomCharacter.vue?vue&type=script&lang=js&"
export * from "./RandomCharacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports